import React, { useEffect, useState } from "react";
import { GET, PGET } from "../../../api/adminApi";
import Select from "react-select";
import { get } from "lodash";

export default function Kvarts() {
  const [items, setItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Секционный",
    value: 1,
  });

  const yearOptions = Array.from({ length: 7 }, (_, i) => {
    const y = 2025 + i;
    return { label: y.toString(), value: y };
  });

  const [year, setYear] = useState(yearOptions[1]);
  const [trademarks, setTrademarks] = useState([]);
  const [trademark, setTrademark] = useState(null);

  async function getTrademarks() {
    const response = await GET(
      `/services/admin/api/product-trademark-helper/${selectedOption.value}`
    );
    if (response?.length) {
      setTrademarks(response);
      setTrademark(response[0]);
    }
  }

  async function getItems() {
    const data = await PGET(
      "/services/admin/api/dashboard-products-sales-quarterly/",
      true,
      {
        year: year.value,
        category: selectedOption.value,
        trademark: get(trademark, "trademarkId", null),
      }
    );

    if (data?.data) {
      setItems(data.data);
    }
  }

  const selectTrademark = (selectedOpt) => {
    setTrademark(selectedOpt);
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    setTrademark(null);
  };

  const options = [
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  useEffect(() => {
    getTrademarks();
  }, [selectedOption]);

  useEffect(() => {
    getItems();
  }, [year, selectedOption, trademark]);

  return (
    <div className="pb-4" style={{ minHeight: 300 }}>
      {/* ГОД */}
      <div style={{ width: 180, position: "absolute", right: 280, top: 15 }}>
        <Select
          className="custom-react-select"
          options={yearOptions}
          value={year}
          onChange={setYear}
          placeholder="Год"
        />
      </div>

      {/* КАТЕГОРИЯ */}
      <div style={{ width: 180, position: "absolute", right: 150, top: 15 }}>
        <Select
          name="regionId"
          className="custom-react-select"
          options={options}
          value={selectedOption}
          onChange={handleChange}
          placeholder="Категория"
        />
      </div>

      {/* ТОРГОВАЯ МАРКА */}
      <div style={{ width: 200, position: "absolute", right: 0, top: 15 }}>
        <Select
          name="tradeId"
          className="custom-react-select" 
          options={trademarks}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.trademarkId}
          value={trademark}
          onChange={selectTrademark}
          placeholder="Торговая марка"
        />
      </div>

      {/* ТАБЛИЦА */}
      <div style={{ overflowX: "auto", }}>
        <table
          className="table bg-white table-rounded table-striped"
          style={{ fontSize: 12 }}
        >
<thead>
  <tr className="text-gray-800 border-gray-200 fw-bold border-bottom-2">
      <th style={{ width: "30px" }} className="text-center">
                №
              </th>
    <th className="text-start">Название продукта</th>
    <th className="text-end">1-квартал</th>
    <th className="text-end">2-квартал</th>
    <th className="text-end">3-квартал</th>
    <th className="text-end">4-квартал</th>
    <th className="text-center">Кол-во в упаковке</th>
  </tr>
</thead>

<tbody>
  {items.length ? (
    items.map((item, index) => (
      <tr key={item.productId || index}>
        <td className="text-centr">{index + 1}</td>
        <td className="text-start">{item.productName}</td>
        <td className="text-end">{item.q1Sum.toLocaleString('ru-Ru')}</td>
        <td className="text-end">{item.q2Sum.toLocaleString('ru-Ru')}</td>
        <td className="text-end">{item.q3Sum.toLocaleString('ru-Ru')}</td>
        <td className="text-end">{item.q4Sum.toLocaleString('ru-Ru')}</td>
        <td className="text-center">{item.sectionCount.toLocaleString('ru-Ru')}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={7} className="py-4 text-center">
        Данные отсутствуют
      </td>
    </tr>
  )}
</tbody>



        </table>
      </div>
    </div>
  );
}
